import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {BehaviorSubject, exhaustMap, tap, take, Observable, of, map} from "rxjs";
import {AuthenticationService} from "./authentication.service";
import {LoaderService} from "./loader.service";
import {ActionResult, UserDetail} from "@model";
import {EnvironmentService} from "./environment.service";

@Injectable({ providedIn:'root' })
export class UserDetailService {

  private static _currentUserDetails: BehaviorSubject<UserDetail | undefined> = new BehaviorSubject<UserDetail | undefined>(undefined);

  get currentUserDetails(): BehaviorSubject<UserDetail | undefined> {
    return UserDetailService._currentUserDetails;
  }

  constructor(private http: HttpClient, private authService: AuthenticationService, private loaderService: LoaderService,
              private environmentService:EnvironmentService) {
  }

  fetchUserProfile(): void {
    this.http.post<ActionResult<UserDetail>>(this.environmentService.getApiUrl() + "/api/user/userprofile", {}).subscribe((actionResult: ActionResult<UserDetail>) => {
      this.currentUserDetails.next(actionResult.result);
    });
  }

  fetchCurrentUserDetails(): Observable<UserDetail | undefined> {
    if (this.currentUserDetails.value) {
      return of(this.currentUserDetails.value);
    } else {
      return this.http.post<ActionResult<UserDetail>>(this.environmentService.getApiUrl() + "/api/user/userprofile", {}).pipe(map((actionResult: ActionResult<UserDetail>) => {
          if (actionResult && actionResult.result) {
            this.currentUserDetails.next(actionResult.result);
            return actionResult.result;
          } else {
            this.currentUserDetails.next(undefined);
            return undefined;
          }
        })
      );
    }
  }

  updateUserProfile(userDetails: UserDetail, onSuccess: () => void, onError: () => void): void {
    this.loaderService.startLoading();
    this.authService.jwtResponse.pipe(take(1), exhaustMap(() => {
      return this.http.post<ActionResult<boolean>>
      (this.environmentService.getApiUrl() + "/api/user/userprofile/update", userDetails);
    })).pipe(tap(() => this.loaderService.dismissLoading())).subscribe((actionResult: ActionResult<boolean>) => {
      if (actionResult.resultCode !== -1) {
        onSuccess();
        this.fetchUserProfile();
      } else {
        onError()
      }
    });
  }

  emptyCurrentUserDetails(): void {
    this.currentUserDetails.next(undefined);
  }
}

